import $ from 'jquery';
import React from 'react';
import { players } from '../../constants/Constants';
import { setLocalStorage } from '../../helpers/tools';

class PlayerSelectionPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: this.props.name,
      version: this.props.version,
    };
  }

  /**
   * Method invoked by the selecting a player in the player selector
   */
  onPlayerChange = () => {
    let playerName = $('#player-selector option:checked')[0].value;

    if (playerName === 'videoTag' || playerName === 'jwplayer') {
      setLocalStorage('playerName', playerName);
      setLocalStorage(
        'playerVersion',
        playerName === 'videoTag' ? 0 : players[playerName].versions[0]
      );

      globalThis.location.reload();
    } else {
      let versionSelectorOptions = $('#version-selector option');

      if (versionSelectorOptions.length) {
        versionSelectorOptions[0].selected = true;
      }

      this.setState({
        name: playerName,
        version: -1,
      });
    }
  };

  /**
   * Method invoked by the selecting a player version in the player version selector
   */
  onVersionChange = () => {
    let playerName = $('#player-selector option:checked')[0].value,
      version = $('#version-selector option:checked')[0].text;

    setLocalStorage('playerName', playerName);
    setLocalStorage('playerVersion', version);

    globalThis.location.reload();
  };

  render() {
    let playerName = this.state.name;

    return (
      <div className="playerSelectionPanel">
        <select
          className="btnGeneral"
          id="player-selector"
          defaultValue={playerName}
          onChange={this.onPlayerChange}
        >
          <option disabled>Choose player:</option>
          {Object.keys(players).map(item => (
            <option key={item} value={item}>
              {players[item].name}
            </option>
          ))}
        </select>
        {playerName === 'videoTag' || playerName === 'jwplayer' || (
          <select
            className="btnGeneral"
            id="version-selector"
            defaultValue={this.state.version}
            onChange={this.onVersionChange}
          >
            <option disabled value="-1">
              Choose version:
            </option>
            {players[playerName].versions.map(item => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        )}
      </div>
    );
  }
}

export default PlayerSelectionPanel;
